import base from './configService'
import { debug } from 'util';
import { store } from '@/store'

const authenticationService = {}

authenticationService.login = function (username, password, domain, hostname) {
  let dataUser = {
    username,
    password,
    domain,
    hostname
  }
  return base.post('/login', dataUser)
    .then(res => {
      return res.data;
    })
    .catch(error => {
      if (!!error && !!error.response && !!error.response.status) {
        if (error.response.status != 400 && error.response.status != 401 && error.response.status != 409) {
          const { commit } = store;
          commit("global/SET_CONEXION", false);
        }
      } else {
        const { commit } = store;
        commit("global/SET_CONEXION", false);
      }

      return Promise.reject(error);
    })
}

authenticationService.getUser = function (id) {
  return base.get('/User/' + id)
    .then(res => {
      return res.data;
    })
    .catch(e => {
      return Promise.reject(e);
    })
}

authenticationService.logout = function () {
  return base.put('/login')
    .then(res => {
      return res.data;
    })
    .catch(e => {
      return Promise.reject(e);
    })
}

authenticationService.changePassword = function (userId, oldPassword, newPassword) {
  let dataPwd = {
    userId,
    oldPassword,
    newPassword
  }
  return base.post('/ChangePassword', dataPwd)
    .then(res => {
      return res.data;
    })
    .catch(e => {
      return Promise.reject(e);
    })
}


export default authenticationService